/**
 * Cart drawer: remove line item in place
 * --------------------------------------
 * The × on each drawer line (snippets/custom-cart-item.liquid) is a plain link
 * to /cart/change?quantity=0, which navigates away and lands on the cart page.
 * This intercepts that click inside #CartDrawer only and does what the drawer's
 * own quantity steppers already do: theme.cart.changeItem(key, 0), then the
 * theme's cart:build (re-renders the drawer contents) + cart:updated (order-min
 * gate, Drop Ship checkbox sync). The drawer stays open; the href remains as
 * the no-JS fallback. The cart page keeps its native behaviour.
 */
(function () {
  if (window.__cartRemoveBound) return;
  window.__cartRemoveBound = true;

  document.addEventListener('click', function (event) {
    var link = event.target.closest('#CartDrawer .cart__remove a');
    if (!link) return;

    var item = link.closest('.cart__item');
    var key = item && item.dataset.key;
    if (!key || !window.theme || !theme.cart) return; // let the link navigate as before

    event.preventDefault();
    if (item.classList.contains('is-removing')) return;

    item.classList.add('is-removing');
    item.style.opacity = '0.4';
    item.style.pointerEvents = 'none';

    theme.cart.changeItem(key, 0)
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function (error) {
        console.error('Cart remove failed:', error);
        item.classList.remove('is-removing');
        item.style.opacity = '';
        item.style.pointerEvents = '';
      });
  });
})();
